import { getNavigationForPath, NAVIGATION_ROOTS } from './centerNavigation';

type MenuItem = {
  path?: string;
  hideInMenu?: boolean;
  access?: string;
  children?: MenuItem[];
};

export function filterShellMenu<T extends MenuItem>(
  items: T[],
  access: Record<string, boolean | undefined>,
  pathname: string,
): T[] {
  const root = NAVIGATION_ROOTS[getNavigationForPath(pathname)];
  return items.flatMap((item) => {
    if (item.hideInMenu || (item.access && !access[item.access])) return [];
    if (
      item.path &&
      Object.values(NAVIGATION_ROOTS).includes(item.path) &&
      item.path !== root
    )
      return [];
    if (!item.children) return [item];
    const children = filterShellMenu(item.children, access, pathname);
    return children.length ? [{ ...item, children } as T] : [];
  });
}
